<template>
    <div class="welcome-landing-root essay-questions-page min-h-screen bg-background">
        <welcome-navbar />
        <essay-questions-landing />
        <welcome-footer />
    </div>
</template>

<script>
import WelcomeNavbar from '@/components/welcome/landing/WelcomeNavbar.vue';
import WelcomeFooter from '@/components/welcome/landing/WelcomeFooter.vue';
import EssayQuestionsLanding from '@/components/welcome/landing/essay-questions/EssayQuestionsLanding.vue';

export default {
    name: 'EssayQuestions',
    components: {
        WelcomeNavbar,
        WelcomeFooter,
        EssayQuestionsLanding,
    },
};
</script>

<style src="@/scss/welcome-landing.css"></style>
<style src="@/scss/essay-questions.css"></style>
<style src="@/seo/seo.css"></style>
